import { render, staticRenderFns } from "./CourseMessageSetting.vue?vue&type=template&id=6060f667&scoped=true"
import script from "./CourseMessageSetting.vue?vue&type=script&lang=ts"
export * from "./CourseMessageSetting.vue?vue&type=script&lang=ts"
import style0 from "./CourseMessageSetting.vue?vue&type=style&index=0&id=6060f667&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060f667",
  null
  
)

export default component.exports